module.exports = __webpack_public_path__ + "7d4272d0c01e52f8cc87b2ba1334a11e.MP4";